/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventScreenNewMobile_event = {
    readonly name: string;
    readonly description: string | null;
    readonly prettyUrl: string;
    readonly startAt: string;
    readonly endAt: string;
    readonly hasVenue: boolean | null;
    readonly hasExternalUrl: boolean | null;
    readonly seoVenue: {
        readonly address: {
            readonly city: string;
            readonly stateProvinceRegionCode: string;
            readonly zipPostalCode: string | null;
            readonly countryCode: string;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"EventScreenNewCoverPhoto_event" | "EventScreenSettingsButton_event" | "EventScreenDateTime_event" | "EventScreenOwner_event" | "EventScreenJoin_event" | "EventScreenPresentations_event" | "EventScreenAttendCard_event" | "EventScreenMap_event">;
    readonly " $refType": "EventScreenNewMobile_event";
};
export type EventScreenNewMobile_event$data = EventScreenNewMobile_event;
export type EventScreenNewMobile_event$key = {
    readonly " $data"?: EventScreenNewMobile_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventScreenNewMobile_event">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenNewMobile_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Venue",
      "kind": "LinkedField",
      "name": "seoVenue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stateProvinceRegionCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipPostalCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenNewCoverPhoto_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenSettingsButton_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenDateTime_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenOwner_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenJoin_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenPresentations_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenAttendCard_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenMap_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
(node as any).hash = '8ea5918774bbb3fd901484cea698beaa';
export default node;
